import request from '@/api/config.js'

// Получение всех марок
export function getCarCompany() {
  return request({
    url: `car-company`,
    method: 'get',
  })
}

// Добавление новой марки
export function createCarCompany(data) {
  return request({
    url: `car-company/create`,
    method: 'post',
    data,
  })
}

// Обновление данных о марке
export function updateCarCompany(data) {
  return request({
    url: `car-company/`,
    method: 'put',
    data,
  })
}

// Удаление марки по ID
export function deleteCarCompany(id) {
  return request({
    url: `car-company/${id}`,
    method: 'delete',
  })
}
